/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SportGymBarbellIcon16Solid = forwardRef('SportGymBarbellIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5 3a1 1 0 0 1 1 1v3h4V4a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1h1a1 1 0 0 1 1 1v1.25h.25a.75.75 0 0 1 0 1.5H15V10a1 1 0 0 1-1 1h-1v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V9H6v3a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-1H2a1 1 0 0 1-1-1V8.75H.75a.75.75 0 0 1 0-1.5H1V6a1 1 0 0 1 1-1h1V4a1 1 0 0 1 1-1h1Z" })));
});
